import React, { useState } from 'react';
import styled from 'styled-components';
import Modal from './Modal';
import Typography from '../Typography';
import Button from '../Button/Button';
import { theme } from '../../theme';
import axiosClient from '../../api/axiosClient';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

const PublishEventModal = ({ isOpen, onClose, eventId, onPublish }) => {
  const { t } = useTranslation('publishEventModal');
  const [isPublishing, setIsPublishing] = useState(false);

  const handlePublish = async () => {
    setIsPublishing(true);
    try {
      const response = await axiosClient.post(`/api/events/${eventId}/publish`);
      if (response.data.success) {
        toast.success(t('messages.publishSuccess'));
        onPublish(response.data.event);
        onClose();
      }
    } catch (error) {
      console.error('Error al publicar el evento:', error);
      toast.error(t('messages.publishError'));
    } finally {
      setIsPublishing(false);
    }
  };

  const handleKeepPrivate = () => {
    onClose();
  };

  if (!isOpen) return null;

  return (
    <Modal onClose={onClose} title={t('title')}>
      <ModalContent>
        <ModalHeader>
          <Typography $variant="body-1-semibold" color={theme.colors.defaultStrong}>
            {t('description')}
          </Typography>
          <Typography $variant="body-2-medium" color={theme.colors.defaultWeak}>
            {t('subtitle')}
          </Typography>
        </ModalHeader>

        <ButtonContainer>
          <Button
            type="button"
            $variant="ghost"
            size="l"
            sizeTablet="l"
            sizeMobile="m"
            onClick={handleKeepPrivate}
            disabled={isPublishing}
          >
            {t('buttons.keepPrivate')}
          </Button>
          <Button
            type="button"
            $variant=""
            size="l"
            sizeTablet="l"
            sizeMobile="m"
            onClick={handlePublish}
            disabled={isPublishing}
          >
            {isPublishing ? t('buttons.publishing') : t('buttons.makePublic')}
          </Button>
        </ButtonContainer>
      </ModalContent>
    </Modal>
  );
};

export default PublishEventModal;

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.sizing.sm};
  max-width: 500px;
  padding: ${({ theme }) => theme.sizing.sm};
  width: 100%;
`;

const ModalHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.sizing.xs};
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.sizing.sm};
  justify-content: flex-end;
`;